var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMetas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    stroke: "#ececec",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9977_6755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.275 11.0476C18.275 15.6497 14.5442 19.3804 9.94217 19.3804C5.34009 19.3804 1.60938 15.6497 1.60938 11.0476C1.60938 6.44556 5.34009 2.71484 9.94217 2.71484",
    strokeWidth: 1.63154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9447 11.0475C14.9447 13.8088 12.7062 16.0472 9.94499 16.0472C7.18374 16.0472 4.94531 13.8088 4.94531 11.0475C4.94531 8.28628 7.18374 6.04785 9.94499 6.04785",
    strokeWidth: 1.6827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9439 12.714C10.8643 12.714 11.6105 11.9678 11.6105 11.0474C11.6105 10.127 10.8643 9.38086 9.9439 9.38086C9.02349 9.38086 8.27734 10.127 8.27734 11.0474C8.27734 11.9678 9.02349 12.714 9.9439 12.714Z",
    strokeWidth: 1.6827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.2383,
    y1: 9.66953,
    x2: 14.7296,
    y2: 6.17817,
    strokeWidth: 1.6827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6047 8.23139L12.8405 8.57359L15.2359 6.1782L19.0001 5.836L16.6047 8.23139Z",
    strokeWidth: 1.6827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8389 4.46711L12.4967 8.23131L14.8921 5.83591L15.2343 2.07172L12.8389 4.46711Z",
    strokeWidth: 1.6827,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9977_6755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2626,
    height: 20.2626,
    fill: "#ececec",
    transform: "translate(0 0.393066)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetas);
export default __webpack_public_path__ + "static/media/icon-metas.997c9fe2d1960b57aea760f7f4e502f3.svg";
export { ForwardRef as ReactComponent };